
/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
    profile: [],
    avatar: null,
    displayname: null,
    language: null,
    country: null,
    town: null,
    gender: null,
    level: null,
  language_modal: false,
  avatar_modal: false,
  learning_total: {}
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
  setProfile(state, payload) {
        state.profile = payload.profile;
    state.avatar = payload.profile.avatar;
        state.displayname = payload.profile.displayname;
    state.country = payload.profile.country;
        state.town = payload.profile.town;
    state.gender = payload.profile.gender;
        state.level = payload.profile.level;
  },
  unsetProfile(state, payload) {
        state.profile = [];
    state.avatar = null;
        state.displayname = null;
    state.country = null;
        state.town = null;
    state.gender = null;
        state.level = null;
  },
  setProfileInfo(state, payload) {
    if(payload.displayname) state.displayname = payload.displayname;
    if(payload.country) state.country = payload.country;
    if(payload.language) state.language = payload.language;
    if(payload.town) state.town = payload.town;
    if(payload.gender) state.gender = payload.gender;
  },
  unsetProfileInfo(state, payload) {
        state.displayname = null;
    state.country = null;
        state.town = null;
    state.gender = null;
  },
  setAvatar(state, payload) {
        state.avatar = payload.profile.avatar;
  },
  unsetAvatar(state, payload) {
        state.avatar = null;
  },
  setLearningTotal(state, payload) {
    state.learning_total = payload;
  },
  unsetLearningTotal(state) {
    state.learning_total = {};
  },
  languageModal(state, payload) {
    state.language_modal = payload
  },
  AvatarModal(state, payload) {
    state.avatar_modal = payload
  },
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
  setProfile: (context, profile) => {
    context.commit('setProfile', profile)
  },
  unsetProfile: (context) => {
    context.commit('unsetProfile');
  },
  setProfileInfo: (context, profile) => {
    context.commit('setProfileInfo', profile)
  },
  unsetProfileInfo: (context) => {
    context.commit('unsetProfileInfo');
  },
  setAvatar: (context, avatar) => {
    context.commit('setAvatar', {avatar})
  },
  unsetAvatar: (context) => {
    context.commit('unsetAvatar');
  },
  setLearningTotal: (context, data) => {
    context.commit('setLearningTotal', data)
  },
  unsetLearningTotal: (context) => {
    context.commit('unsetLearningTotal');
  },
  languageModal: (context, data) => {
    context.commit('languageModal', data)
  },
  AvatarModal: (context, data) => {
    context.commit('AvatarModal', data)
  }
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  profile: (state) => {
    return state.profile
  },
  profile_info: (state) => {
    return { 
      displayname: state.displayname,
      gender: state.gender,
      country: state.country,
      language: state.language,
      level: state.level
    }
  },
  learning_total: (state) => {
    return state.learning_total
  },
  language_modal: (state) => {
    return state.language_modal
  },
  avatar_modal: (state) => {
    return state.avatar_modal
  }
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state: initialState,
  mutations,
  actions,
  getters
}